import { createStandaloneToast } from '@chakra-ui/react'
import { createApi } from '@reduxjs/toolkit/query/react'
import { API_ENDPOINTS } from 'Constants'
import { resetUser, updateUserDetails } from 'features/Authentication'
import { IUserCredentials } from 'Models/RequestModels'
import { IAuthenticatedUser } from 'Models/ResponseModels'
import { ISpData } from 'Models/ResponseModels/Equitas'
import { foundationUrlQuery } from 'Services/baseQuery'
import { ToastService } from 'Services/toast.service'

export const authenticationApi = createApi({
  reducerPath: 'authenticationApi',
  baseQuery: foundationUrlQuery,
  tagTypes: ['Login', 'Logout'],
  endpoints: (builder) => ({
    loginWithCredentials: builder.mutation<IAuthenticatedUser, IUserCredentials>({
      query: (formData: IUserCredentials) => ({
        url: API_ENDPOINTS.LOGIN,
        method: 'POST',
        body: formData,
        headers: { 'Content-Type': 'application/json', Lang: 'EN' },
      }),
      // async onQueryStarted(_, { dispatch, queryFulfilled }) {
      //   try {
      //     const { data: user } = await queryFulfilled
      //     // dispatch(updateUserDetails(user))
      //     // ToastService.showSuccessTaost({
      //     //   title: 'Success',
      //     //   message: 'Login Successful',
      //     // })
      //   } catch (err: any) {
      //     // TODO: add failure toast here
      //     console.log('Errrr...', err)
      //     ToastService.showErrorToast({ title: 'Error', message: err['error']['message'] })
      //   }
      // },
    }),
    logout: builder.mutation<void, null>({
      query: () => ({
        url: API_ENDPOINTS.LOGOUT,
        method: 'POST',
      }),
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled
          dispatch(resetUser())
          ToastService.showSuccessTaost({
            title: 'Success',
            message: 'Logout Successful',
          })
        } catch (e: any) {
          // console.log(e)
          ToastService.showErrorToast({
            title: e['error']['data']['detail'] ?? 'Something went wrong',
          })
        }
        //  finally {
        //   dispatch(resetUser())
        // }
      },
    }),
    getSpListing: builder.query<
      ISpData[],
      { user_id: string; type?: string; journey_type?: string, list_user_of?: string }
    >({
      query: (params) => ({
        url: API_ENDPOINTS.SP_LISTING,
        method: 'GET',
        params: params,
      }),
      keepUnusedDataFor: 0.0001,
    }),
    spTaggingSendOtp: builder.mutation<
      string,
      {
        email: string
      }
    >({
      query: (payload) => ({
        url: API_ENDPOINTS.SP_TAGGING_SEND_OTP,
        method: 'POST',
        body: payload,
        headers: { 'Content-Type': 'application/json', Lang: 'EN' },
      }),
    }),
    getBranchListing: builder.query<any, any>({
      query: (params) => ({
        url: '/accounts/branchlisting',
        method: 'GET',
        params: params,
      }),
      keepUnusedDataFor: 0.0001,
    }),
  }),
})

export const {
  useLoginWithCredentialsMutation,
  useLogoutMutation,
  useGetSpListingQuery,
  useSpTaggingSendOtpMutation,
  useLazyGetBranchListingQuery,
  useGetBranchListingQuery,
} = authenticationApi
